module.exports = __webpack_public_path__ + "media/images/img-car-1-813be652.png";